export default function translate(i18n, propriete) {
  if (propriete === 'siren') {
    return i18n.t('client.siren');
  }
  return propriete;
}



// WEBPACK FOOTER //
// ./src/services/client/translator.js